import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, normalizeClass as _normalizeClass, withModifiers as _withModifiers, Teleport as _Teleport } from "vue"
import _imports_0 from '@/assets/avatar-skeleton.svg'
import _imports_1 from '@/assets/avatar-unknown.svg'


const _hoisted_1 = {
  key: 0,
  class: "aside__profile"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Profile Picture Skeleton",
  class: "aside__avatar"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "aside__nickname" }, " ", -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = {
  key: 0,
  class: "aside__profile aside__profile--logged-in"
}
const _hoisted_6 = { class: "aside__profile-settings-link" }
const _hoisted_7 = { class: "aside__nickname" }
const _hoisted_8 = {
  key: 1,
  class: "aside__profile"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "No User Generic Profile Picture",
  class: "aside__avatar"
}, null, -1)
const _hoisted_10 = { class: "aside__nickname" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "aside__line aside__line--top" }, null, -1)
const _hoisted_12 = { class: "aside__main-content" }
const _hoisted_13 = { class: "aside__navigation" }
const _hoisted_14 = { class: "aside__links" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "aside__link-desc" }, "Таблица", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "aside__link-desc" }, "Калькулятор", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "aside__link-desc" }, "Сборки", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "aside__link-desc" }, "События", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "aside__line" }, null, -1)
const _hoisted_20 = { class: "aside__links" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "aside__link-desc" }, "Мои сборки", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "aside__link-desc" }, "Сохраненные", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "aside__line" }, null, -1)
const _hoisted_24 = { class: "aside__links" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", { class: "aside__link-desc" }, "Админка", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "aside__line" }, null, -1)
const _hoisted_27 = { class: "aside__links" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", { class: "aside__link-desc" }, "Настройки", -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("span", { class: "aside__link-desc" }, "Связаться", -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("span", { class: "aside__link-desc" }, "Выйти", -1)
const _hoisted_31 = { class: "aside__footer" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "aside__footer-legal" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Enlisted — зарегистрированная товарная марка Gaijin Games Kft."),
  /*#__PURE__*/_createElementVNode("p", null, " Этот сайт не аффилирован с Gaijin Games Kft. Все игровые изображения и имена являются собственностью Gaijin Games Kft. ")
], -1)
const _hoisted_33 = { class: "aside__footer-links" }
const _hoisted_34 = { class: "aside__hamburger-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserAvatar = _resolveComponent("UserAvatar")!
  const _component_IconCog = _resolveComponent("IconCog")!
  const _component_IconBase = _resolveComponent("IconBase")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_IconAngleDoubleUp = _resolveComponent("IconAngleDoubleUp")!
  const _component_IconUserCog = _resolveComponent("IconUserCog")!
  const _component_IconBookOpen = _resolveComponent("IconBookOpen")!
  const _component_IconCalendar = _resolveComponent("IconCalendar")!
  const _component_IconHammer = _resolveComponent("IconHammer")!
  const _component_IconBookmark = _resolveComponent("IconBookmark")!
  const _component_IconCrown = _resolveComponent("IconCrown")!
  const _component_IconDiscord = _resolveComponent("IconDiscord")!
  const _component_IconSignOut = _resolveComponent("IconSignOut")!
  const _component_IconHamburger = _resolveComponent("IconHamburger")!
  const _component_IconTimes = _resolveComponent("IconTimes")!
  const _component_LoginOrRegister = _resolveComponent("LoginOrRegister")!
  const _component_ContactsModal = _resolveComponent("ContactsModal")!
  const _directive_ripple = _resolveDirective("ripple")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("aside", {
      class: _normalizeClass(["aside", { visible: _ctx.$store.state.isNavigationVisible }])
    }, [
      (!_ctx.$store.state.loading.isAuthInitialized)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (_ctx.$store.state.user.isLoggedIn)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createVNode(_component_UserAvatar, { class: "aside__avatar" }),
                  _createElementVNode("div", _hoisted_6, [
                    _withDirectives((_openBlock(), _createBlock(_component_router_link, {
                      onClick: _ctx.hideNavigationVisibility,
                      to: "/settings"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_IconBase, {
                          width: 20,
                          height: 20
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_IconCog)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["onClick"])), [
                      [_directive_ripple]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$store.state.user.displayName), 1)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _hoisted_9,
                  _createElementVNode("div", _hoisted_10, [
                    _withDirectives((_openBlock(), _createElementBlock("button", {
                      onClick: _cache[0] || (_cache[0] = ($event: any) => {
								_ctx.hideNavigationVisibility;
								_ctx.$store.state.modal.isLoginModalVisible = true;
							}),
                      class: "btn btn-sm btn-tertiary"
                    }, [
                      _createTextVNode(" Войти ")
                    ])), [
                      [_directive_ripple]
                    ])
                  ])
                ]))
          ], 64)),
      _hoisted_11,
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("nav", _hoisted_13, [
          _createElementVNode("section", _hoisted_14, [
            _withDirectives((_openBlock(), _createBlock(_component_router_link, {
              onClick: _ctx.hideNavigationVisibility,
              class: "aside__link",
              to: "/"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_IconBase, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_IconAngleDoubleUp)
                  ]),
                  _: 1
                }),
                _hoisted_15
              ]),
              _: 1
            }, 8, ["onClick"])), [
              [_directive_ripple]
            ]),
            _withDirectives((_openBlock(), _createBlock(_component_router_link, {
              onClick: _ctx.hideNavigationVisibility,
              class: "aside__link",
              to: "/calculator"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_IconBase, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_IconUserCog)
                  ]),
                  _: 1
                }),
                _hoisted_16
              ]),
              _: 1
            }, 8, ["onClick"])), [
              [_directive_ripple]
            ]),
            _withDirectives((_openBlock(), _createBlock(_component_router_link, {
              onClick: _ctx.hideNavigationVisibility,
              class: "aside__link",
              to: "/skill-builds"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_IconBase, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_IconBookOpen)
                  ]),
                  _: 1
                }),
                _hoisted_17
              ]),
              _: 1
            }, 8, ["onClick"])), [
              [_directive_ripple]
            ]),
            _withDirectives((_openBlock(), _createBlock(_component_router_link, {
              onClick: _ctx.hideNavigationVisibility,
              class: "aside__link",
              to: "/events"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_IconBase, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_IconCalendar)
                  ]),
                  _: 1
                }),
                _hoisted_18
              ]),
              _: 1
            }, 8, ["onClick"])), [
              [_directive_ripple]
            ])
          ]),
          (_ctx.$store.state.user.isLoggedIn)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _hoisted_19,
                _createElementVNode("section", _hoisted_20, [
                  _withDirectives((_openBlock(), _createBlock(_component_router_link, {
                    onClick: _ctx.hideNavigationVisibility,
                    class: "aside__link",
                    to: "/my-builds"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_IconBase, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_IconHammer)
                        ]),
                        _: 1
                      }),
                      _hoisted_21
                    ]),
                    _: 1
                  }, 8, ["onClick"])), [
                    [_directive_ripple]
                  ]),
                  _withDirectives((_openBlock(), _createBlock(_component_router_link, {
                    onClick: _ctx.hideNavigationVisibility,
                    class: "aside__link",
                    to: "/saved-builds"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_IconBase, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_IconBookmark)
                        ]),
                        _: 1
                      }),
                      _hoisted_22
                    ]),
                    _: 1
                  }, 8, ["onClick"])), [
                    [_directive_ripple]
                  ])
                ])
              ], 64))
            : _createCommentVNode("", true),
          (_ctx.$store.state.user.isAdmin)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _hoisted_23,
                _createElementVNode("section", _hoisted_24, [
                  _withDirectives((_openBlock(), _createBlock(_component_router_link, {
                    onClick: _ctx.hideNavigationVisibility,
                    class: "aside__link",
                    to: "/admin"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_IconBase, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_IconCrown)
                        ]),
                        _: 1
                      }),
                      _hoisted_25
                    ]),
                    _: 1
                  }, 8, ["onClick"])), [
                    [_directive_ripple]
                  ])
                ])
              ], 64))
            : _createCommentVNode("", true),
          _hoisted_26,
          _createElementVNode("section", _hoisted_27, [
            _withDirectives((_openBlock(), _createBlock(_component_router_link, {
              onClick: _ctx.hideNavigationVisibility,
              class: "aside__link",
              to: "/settings"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_IconBase, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_IconCog)
                  ]),
                  _: 1
                }),
                _hoisted_28
              ]),
              _: 1
            }, 8, ["onClick"])), [
              [_directive_ripple]
            ]),
            _withDirectives((_openBlock(), _createElementBlock("button", {
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.showContactsModal && _ctx.showContactsModal(...args))),
              class: "aside__link",
              to: "/contacts"
            }, [
              _createVNode(_component_IconBase, null, {
                default: _withCtx(() => [
                  _createVNode(_component_IconDiscord)
                ]),
                _: 1
              }),
              _hoisted_29
            ])), [
              [_directive_ripple]
            ]),
            (_ctx.$store.state.user.isLoggedIn)
              ? _withDirectives((_openBlock(), _createElementBlock("button", {
                  key: 0,
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleSignOut && _ctx.handleSignOut(...args))),
                  class: "aside__link",
                  to: "/sign-out"
                }, [
                  _createVNode(_component_IconBase, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_IconSignOut)
                    ]),
                    _: 1
                  }),
                  _hoisted_30
                ])), [
                  [_directive_ripple]
                ])
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("footer", _hoisted_31, [
          _hoisted_32,
          _createElementVNode("div", _hoisted_33, [
            _createVNode(_component_router_link, {
              onClick: _ctx.hideNavigationVisibility,
              to: "/privacy"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Политика конфиденциальности")
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createTextVNode(" | "),
            _createVNode(_component_router_link, {
              onClick: _ctx.hideNavigationVisibility,
              to: "/user-agreement"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Пользовательское соглашение")
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createTextVNode(" | "),
            _createVNode(_component_router_link, {
              onClick: _ctx.hideNavigationVisibility,
              to: "/licenses"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Лицензии инструментов")
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ])
      ])
    ], 2),
    (_ctx.$store.state.isNavigationVisible)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "page-mask",
          onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleNavigationVisibility && _ctx.toggleNavigationVisibility(...args)), ["stop"]))
        }))
      : _createCommentVNode("", true),
    (_ctx.mounted)
      ? (_openBlock(), _createBlock(_Teleport, {
          key: 1,
          to: "#screen-bottom"
        }, [
          _createElementVNode("div", _hoisted_34, [
            _withDirectives((_openBlock(), _createElementBlock("button", {
              class: "btn btn-secondary aside__hamburger-btn",
              tabindex: "1",
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.toggleNavigationVisibility && _ctx.toggleNavigationVisibility(...args)))
            }, [
              _createVNode(_component_IconBase, {
                width: 24,
                height: 24,
                class: _normalizeClass(["aside__hamburger-icon", { visible: !_ctx.$store.state.isNavigationVisible }])
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_IconHamburger)
                ]),
                _: 1
              }, 8, ["class"]),
              _createVNode(_component_IconBase, {
                width: 24,
                height: 24,
                class: _normalizeClass(["aside__hamburger-icon", { visible: _ctx.$store.state.isNavigationVisible }])
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_IconTimes)
                ]),
                _: 1
              }, 8, ["class"])
            ])), [
              [_directive_ripple]
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.$store.state.modal.isLoginModalVisible)
      ? (_openBlock(), _createBlock(_component_LoginOrRegister, { key: 2 }))
      : _createCommentVNode("", true),
    (_ctx.$store.state.modal.isContactsModalVisible)
      ? (_openBlock(), _createBlock(_component_ContactsModal, { key: 3 }))
      : _createCommentVNode("", true)
  ], 64))
}